import React, { useEffect, useState } from 'react';
import { Spin, Tag } from 'antd';
import {
  OrderStatus,
  PayStatus,
  BillTypes,
  BillStatus,
  VoucherStatus,
  TransactionTypes,
  SupplierStatus,
  ReviewStatus,
  LeadStatus,
  CampaignType,
  CampaignStatus,
} from '../../utils/constant';
import IntlMessages from '../../components/IntlMessage';

const Status = (props) => {
  const { status, type } = props;
  const [value, setValue] = useState('');
  const [color, setColor] = useState('');

  useEffect(() => {
    if (status) {
      setValue(status);
    }
    if (type === 'order') {
      setColor(OrderStatus[status]?.color);
    } else if (type === 'pay') {
      setColor(PayStatus[status]?.color);
    } else if (type === 'bill') {
      setColor(BillStatus[status]?.color);
    } else if (type === 'voucher') {
      setColor(VoucherStatus[status]?.color);
    } else if (type === 'transaction') {
      setColor(TransactionTypes[status]?.color);
    } else if (type === 'supplier') {
      setColor(SupplierStatus[status]?.color);
    } else if (type === 'review') {
      setColor(ReviewStatus[status]?.color);
    } else if (type === 'lead') {
      setColor(LeadStatus[status]?.color);
    } else if (type === 'campaign') {
      setColor(CampaignType[status]?.color);
    } else if (type === 'campaign_status') {
      setColor(CampaignStatus[status]?.color);
    } else {
      setColor(BillTypes[status]?.color);
    }
  }, [status, type]);

  return (
    <Spin spinning={value === '' || color === ''}>
      {value !== '' && color !== '' && (
        <Tag color={color}>
          <IntlMessages id={`global.${value}`} />
        </Tag>
      )}
    </Spin>
  );
};

export default Status;
